import React from "react";
import Card from "react-bootstrap/Card";
import { ImArrowRight2 } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Basel Ashraf </span>
            from <span className="purple">Cairo, EG.</span>
            <br />
            I am currently a Computer Engineering and Software Systems student at the University of East London.
            <br />
			<br />
            I am specializing in machine learning, computer vision, and data science.
            <br />
            <br />
            Apart from coding, some other activities that I love to do related to machine learning and technology are:
          </p>
          <ul>
            <li className="about-activity">
              <ImArrowRight2 /> Experimenting with new machine learning algorithms and models
            </li>
            <li className="about-activity">
              <ImArrowRight2 /> Contributing to open-source machine learning projects
            </li>
            <li className="about-activity">
              <ImArrowRight2 /> Attending machine learning conferences and workshops
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "In the world of machine learning, every line of code written has the potential to reshape the future."{" "}
          </p>
          <footer className="blockquote-footer">Basel Ashraf </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
